module.exports = __webpack_public_path__ + "img/3.4beef5f7.jpg";